"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostOrderAdd = void 0;
const Base_1 = require("./Base");
exports.PostOrderAdd = {
    url: Base_1.URL_BASE + "/OrderAdd",
    method: "POST",
    secure: true
};
//# sourceMappingURL=PostOrderAdd.js.map